import { combineReducers } from 'redux'

import arquivosDespesasCartaoCorporativo from './arquivosDespesasCartaoCorporativo'

export default combineReducers({ arquivosDespesasCartaoCorporativo })
